// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

// MODOC's official definition of a "significant other" for the Positive
// Contact with Significant Other task (and its initial-contact variants).
// Shared across those task classes so the copy can't drift between them.
export const US_MO_SIGNIFICANT_OTHER_DEFINITION =
  "A family member, romantic partner, or close friend who is important or influential in one's life.";
